import { GoalCategory } from "../types";

export const GOAL_OPTIONS = [
  {
    label: "Car",
    value: "CAR",
  },
  {
    label: "House",
    value: "HOUSE",
  },
  {
    label: "Wedding",
    value: "MARRIAGE",
  },
  {
    label: "Child education",
    value: "CHILD_EDU",
  },
  {
    label: "Retirement",
    value: "RETIREMENT",
  },
  {
    label: "Custom",
    value: "CUSTOM",
  },
] as const;

export const GoalTargetCorpusLabelMap: Record<GoalCategory, string> = {
  MARRIAGE: "Estimated wedding expenses",
  HOUSE: "Down payment for house",
  CAR: "Car price",
  CHILD_EDU: "Estimated education cost",
  RETIREMENT: "Retirement corpus",
  CUSTOM: "Target corpus",
};
